import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

declare const grecaptcha:any;

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

grecaptcha.ready(function () {
  grecaptcha.execute('6Lf_Fs8UAAAAAKW1QVedfDl5p4aCPz-ovF_Y5Mnw', { action: 'homepage' })
    .then((token:any) => {
      // console.log('token', token);
      window.grecaptcha_token = token;
    })
});

